
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import type { ClasshourDetail as TClasshourDetail } from '@xt/client/entities/course-v2/types.d'
import EmptyStatus from '@xt/www/components/emptyStatus/index.vue'
import { EnumEmptyStatus } from '@xt/client/utils/empty-status/index'
import Qrcode from '@xt/www/components/showQrcode/index.vue'

@Observer
@Component({
  components: {
    EmptyStatus,
    Qrcode
  }
})
export default class ClasshourWenfang extends Vue {
  @Prop({ default: () => [] }) data: TClasshourDetail['wenfangProductList']

  get EnumEmptyStatus() {
    return EnumEmptyStatus
  }

  created() {}
  mounted() {}
  updated() {}
  destroyed() {}
}
